define(function (require) {
    'use strict';

    require('./env');
    var _ = require('underscore');
    var apiUrl = window.API_LOCATION || document.domain;

    /**
     * @lends {AppConfig}
     */
    return {
        DEBUG: false,
        host: '//' + apiUrl,
        loggerUrl: '/rest/error',
        STATUS_OK: 1,
        STATUS_ERROR: 0,
        locale: {
            date_format: 'DD.MM.YYYY',
            date_format_min: 'DD.MM.YY',
            time_format: 'HH:mm:ss',
            time_format_min: 'HH:mm',
            price_format: '',
            currency_suffix: '',
            currency_prefix: ''
        },
        notify: {
            url: location.protocol.replace('http', 'ws') + '//' + window.API_WEBSOCKET
        },
        table: {
            curPage: 1,
            amount: 20
        },
        pagination: {
            defaultPage: 1,
            defaultPageSize: 20
        },
        browser: {
            isChrome: navigator.userAgent.match(/Chrome/),
            isSafary: navigator.userAgent.match(/Safari/),
            isFirefox: navigator.userAgent.match(/Firefox/),
            isMSIE: navigator.userAgent.match(/MSIE/)
        },
        platform: {
            isWin: navigator.platform.match(/Win/) || navigator.userAgent.match(/Windows/),
            isMac: navigator.platform.match(/Mac/)
        },
        log: function () {

        },
        hiddenFieldTemplate: '●●●●●●●●●●',
        defaultStaffGroups: function () {
            var defaultGroups = [
                { id: 1, name: 'Группа 1' },
                { id: 2, name: 'Группа 2' },
                { id: 3, name: 'Группа 3' },
                { id: 4, name: 'Группа 4' }
            ];
            _.each(defaultGroups, function (group, index) {
                Backbone.ajax({
                    url: this.host + '/rest/staff/group',
                    type: 'POST',
                    data: JSON.stringify({name: group.name})
                });

            }.bind(this));

            return defaultGroups;
        }
    };
});
